module.exports = __webpack_public_path__ + "static/media/nimbus.45a59cac.png";